export default __webpack_public_path__ + "static/media/footerbg.f9d62a16.png";